<template>
  <div v-if="!showModal" class="main-contents">
    <withdrawn
      v-if="userInfoStore.userDetail.user_state == WITHDRAWN"
    ></withdrawn>
    <!-- 公募案件 -->
    <public-solicitation
      v-if="
        projectStore.selectedTab == 0 &&
        !showModal &&
        userInfoStore.userDetail.user_state != WITHDRAWN &&
        userInfoStore.userDetail.id
      "
    />
    <!--お気に入り-->
    <favorite
      v-else-if="
        projectStore.selectedTab == 3 &&
        !showModal &&
        userInfoStore.userDetail.user_state != WITHDRAWN &&
        userInfoStore.userDetail.id
      "
    />
    <applied
      v-else-if="
        projectStore.selectedTab == 1 &&
        !showModal &&
        userInfoStore.userDetail.user_state != WITHDRAWN &&
        userInfoStore.userDetail.id
      "
    />
    <!-- マイページ -->
    <my-page
      v-else-if="
        projectStore.selectedTab == 2 &&
        !showModal &&
        userInfoStore.userDetail.user_state != WITHDRAWN &&
        userInfoStore.userDetail.id
      "
    />
    <div v-else></div>
  </div>
  <Footer
    v-if="!showModal || userInfoStore.userDetail.user_state != WITHDRAWN"
  ></Footer>
  <regist-modal v-model="showModal" />
</template>

<script setup lang="ts">
import PublicSolicitation from "./PublicSolicitation.vue";
import Applied from "./Applied.vue";
import MyPage from "./MyPage.vue";
import Footer from "./Footer.vue";
import { onMounted, ref } from "vue";
import { ProjectStore } from "../store/ProjectStore";
import RegistModal from "./RegistModal.vue";
import { UserInfoStore } from "../store/UserInfoStore";
import { WITHDRAWN } from "../consts/common";
import Withdrawn from "./Withdrawn.vue";
import Favorite from "./Favorite.vue";
import { signIn } from "../services/UserInfoService";
import router from "../router";
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let url: any = "";
const projectStore = ProjectStore();
const userInfoStore = UserInfoStore();
const showModal = ref(false);

onMounted(async () => {
  window.addEventListener("popstate", function () {
    if (userInfoStore.isRegistFromProjectDetail.show) {
      userInfoStore.setIsRegistFromProjectDetail({
        show: false,
        title: "",
        mediaType: -1,
      });
      router.push("/project-detail");
    }
  });

  // liff起動時にtoken更新
  await signIn();
  await userInfoStore
    .getUserDetail()
    .then(() => {
      if (!userInfoStore.userDetail.id) {
        showModal.value = true;
        return;
      } else {
        showModal.value = false;
      }
      if (
        userInfoStore.userDetail.user_state != WITHDRAWN &&
        projectStore.notification.total < 0
      ) {
        projectStore.getNotification();
      }
      if (!userInfoStore.userSnsInfo.length) {
        userInfoStore.getUserSnsAccount();
      }
      if (!userInfoStore.bankInfo.id) {
        userInfoStore.getBankInfo();
      }
      if (userInfoStore.addressInfo.id < 0) {
        userInfoStore.getAddressInfo();
      }
        const url_string = window.location.href;
  // 文字列としてのURLをURLオブジェクトに変換する。
  url = new URL(url_string).search;
  // statusがpathに入っている場合はstatusも入れる
  if (projectStore.selectedTab >= 0) {
    return;
  } else if (url.match(/status/)) {
    const applied = url.split("?selectedTitleId=1&status=");
    projectStore.setSelectedStatus(+applied[1]);
    projectStore.setSelectedTab(1);
  } else if (url.match(/selectedTitleId/)) {
    const result = url.split("?selectedTitleId=");
    projectStore.setSelectedTab(+result[1]);
    // 応募済案件詳細
  } else if (url.match(/projectId/)) {
    // 退会済の場合は案件詳細は表示しない
    if (userInfoStore.userDetail.user_state == WITHDRAWN) return;
    const result = url.split("?projectId=");
    // lineの通知のurlから来た場合は応募済案件詳細に遷移する
    projectStore.setSelectedId(+result[1]);
    router.push("/applied-project-detail");
    projectStore.setSelectedTab(1);
    document.title = "OMOT Influencer";
  }  else if (url.match(/recommendationProjectId/)) {
    // 退会済の場合は案件詳細は表示しない
    if (userInfoStore.userDetail.user_state == WITHDRAWN) return;
    const result = url.split("?recommendationProjectId=");
    // lineの通知のurlから来た場合は案件詳細に遷移する
    projectStore.setSelectedId(+result[1]);
    router.push("/project-detail");
    document.title = "OMOT Influencer";
    projectStore.setSelectedTab(0);
  } else if (url.match(/address/)) {
    // LINEメッセージから 住所新規登録の場合
    // 退会済の場合は案件詳細は表示しない
    if (userInfoStore.userDetail.user_state == WITHDRAWN) return;
    projectStore.setSelectedTab(2);
    router.push("/address");
  } else {
    projectStore.setSelectedTab(0);
  }
    })
    .catch(() => {
      showModal.value = true;
      return;
    });
});
</script>

<style scoped lang="scss">
@import "../assets/style/_variables.scss";
@import "../assets/style/_mixin.scss";

.main-contents {
  height: calc(100% - 75px);
  overflow: hidden;
}
</style>
